// extracted by mini-css-extract-plugin
var _1 = "NotificationStyle-module__action___KxtBW";
var _2 = "NotificationStyle-module__error___Fv39R";
var _3 = "NotificationStyle-module__fadeout___dQa0A";
var _4 = "NotificationStyle-module__info___iCqdF";
var _5 = "NotificationStyle-module__notification___A21hG";
var _6 = "NotificationStyle-module__notification-fixed___fPuuE";
var _7 = "NotificationStyle-module__notification-fixed___fPuuE";
var _8 = "NotificationStyle-module__success___QLLix";
export { _1 as "action", _2 as "error", _3 as "fadeout", _4 as "info", _5 as "notification", _6 as "notification-fixed", _7 as "notificationFixed", _8 as "success" }
